import { Component, OnInit } from '@angular/core';
import { ROUTES, YODAROUTES } from './sidebar-routes.config';
import { SELECTIVEROUTES } from './sidebar-routes.config';
import { RouteInfo } from "./sidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
//import { CookieService } from 'ngx-cookie-service';
import {CookieService} from '../../data-worker/cookie.service';
import Auth from '@aws-amplify/auth';

declare var $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];

    public logo: string;
    usertype;
    filtered_routes = [];

    // dictonary mapping cognition subdomains (portals) with their respective portal logos
    domainToImageUrl = {
        'portal.cognition.world': 'assets/img/logo_1.png',
        'irishcommodities.cognition.world': 'assets/img/irish_como_logo1.png',
        'energia.cognition.world': 'assets/img/connect360-white.png'
        // Add more entries as needed
    };

    constructor(private router: Router,
        private route: ActivatedRoute, public translate: TranslateService, private cookieService: CookieService) {
        
    }

    checkForUserLogin(){
        const userCheck = Auth.currentAuthenticatedUser({bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      }).then(user_ => {
        ////console.log(user_)
        this.usertype = user_.attributes["custom:usertype"]
        this.filtered_routes = []
        ROUTES.forEach(
            (r) => {
                ////console.log(r)
                if (r.isDemo == true){
                    if (this.usertype == "4" || this.usertype == 4){
                        this.filtered_routes.push(r)
                        ////console.log("adding demo route")
                    }
                }else {
                    this.filtered_routes.push(r)
                }
            }
        )

        ////console.log(this.filtered_routes)

        $.getScript('./assets/js/app-sidebar.js');
        // /delay(2000);
        let allowedModules0 = this.cookieService.get('modBus');

        ////console.log("aftercheck for user login")

        let user = this.cookieService.get('appUsername');
        let user_type = this.cookieService.get('rulerGuide');
        ////console.log("sidebar username - " + user_type)
        this.logo = "logo_3.png"
        // this.logo = "logo_1.png"
        // if (user == "cognition.demo") {this.logo = "logo_hsc_partner.png";}
        let allowedModules = JSON.parse(allowedModules0);
      //console.log(allowedModules[0]);
        if (allowedModules.indexOf("all") > -1){
            // if (this.usertype == "4" || this.usertype == 4) {
            //     ////console.log("within demo")
            //     ////console.log(this.usertype == "4", this.usertype == 4)
            //     this.menuItems = ROUTES.filter(menuItem => {
            //         return menuItem
            //     });

            // }else{
            // this.menuItems = this.filtered_routes
            // }
            // this.menuItems = this.filtered_routes.filter(menuItem => {
            //     return menuItem
            // })
            this.menuItems = this.filtered_routes
            ////console.log(this.usertype)
            ////console.log(this.menuItems)

        }
        else if (allowedModules.indexOf("yoda") > -1){
            this.menuItems = YODAROUTES.filter(menuItem => menuItem);
        }
        else {
            let modules = allowedModules[0];
            this.menuItems = [];
            if (modules.dashboard){
                this.menuItems.push(SELECTIVEROUTES['dashboard'])
            }
            if (modules.alertcentre){
                this.menuItems.push(SELECTIVEROUTES['alertcentre'])
            }
            if (modules.yoursensors){
                this.menuItems.push(SELECTIVEROUTES['yoursensors'])
            }
            if (modules.sustainability){
                let sustainabilityMenu = SELECTIVEROUTES['sustainability']
                modules.sustainability.forEach(subs => {
                    sustainabilityMenu.submenu.push(SELECTIVEROUTES[subs])
                });
                this.menuItems.push(sustainabilityMenu)
            }
            if (modules.activity){
                // alert(modules.activity)
                let activityMenu = SELECTIVEROUTES['activity']
                modules.activity.forEach(subs => {
                    activityMenu.submenu.push(SELECTIVEROUTES[subs])
                });
                this.menuItems.push(activityMenu)
            }
            if (modules.quality){
                let qualityMenu = SELECTIVEROUTES['quality']
                modules.quality.forEach(subs => {
                    qualityMenu.submenu.push(SELECTIVEROUTES[subs])
                });
                this.menuItems.push(qualityMenu)
            }
            if (modules.assetmanagement){
                let assetmanagementMenu = SELECTIVEROUTES['assetmanagement']
                modules.assetmanagement.forEach(subs => {
                    assetmanagementMenu.submenu.push(SELECTIVEROUTES[subs])
                });
                this.menuItems.push(assetmanagementMenu)
            }
            if (modules.compliance){
                let complianceMenu = SELECTIVEROUTES['compliance']
                modules.compliance.forEach(subs => {
                    complianceMenu.submenu.push(SELECTIVEROUTES[subs])
                });
                this.menuItems.push(complianceMenu)
            }
        }
      })
    }

    ngOnInit() {
        this.checkForUserLogin()
        //this.menuItems.push(ROUTES2);
        
        
        //alert(JSON.stringify(this.menuItems));
      //console.log(this.menuItems);
    }

        // function gets portal logo based on the subdomain accessed; return cognition logo by default
        getDomainLogo(): string {
            // Get the current domain/sub-domain
            const currentDomain = window.location.hostname;
        
            // Check if the current domain/sub-domain exists in the mapping
            if (this.domainToImageUrl.hasOwnProperty(currentDomain)) {
                return this.domainToImageUrl[currentDomain];
            } else {
                // Default image URL in case of no match
                return 'assets/img/logo_1.png';
            }
        }

    //NGX Wizard - skip url change
    ngxWizardFunction(path: string) {
        if (path.indexOf('forms/ngx') !== -1)
            this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts